import $ from 'jquery';

import * as Website from '../Config/Website.js';


const Modal = {
  openClass: '.js-modalOpen',
  closeClass: '.js-modalClose',
  wrapperClass: '.js-modal',
  init() {
    this.open();
    this.close();
  },
  open() {
    $(document).on('click', this.openClass, function() {
      const target = $(this).attr('href') || $(this).data('target');
      const targetElm = $(`${Modal.wrapperClass + target}`);
      $('html').addClass(Website.classList.modalOpen);
      if(typeof Iscroll !== "undefined" && Iscroll.instance) {
        Iscroll.stop();
      }
      targetElm.fadeIn(function(){
        $(this).addClass(Website.classList.act);
        if($(this).find('video').length) {
          $(this).find('video').get(0).play();
        }
        if($(this).find('iframe').length) {
          $(this).find('iframe').each(function() {
            if($(this).attr('src').indexOf("youtube" > -1) && $(this).attr('src').indexOf("enablejsapi=1") > -1) {
              const message = '{"event":"command","func":"playVideo","args":""}';
              $(this).get(0).contentWindow.postMessage(message, "*");
            }
          });
        }
      })
      return false;
    });
  },
  close(){
    $(document).on('click', this.closeClass, function() {
      if($(this).closest(Modal.wrapperClass).find('video').length) {
        $(this).closest(Modal.wrapperClass).find('video').get(0).pause();
      }
      if($(this).closest(Modal.wrapperClass).find('iframe').length) {
        $(this).closest(Modal.wrapperClass).find('iframe').each(function() {
          if($(this).attr('src').indexOf("youtube" > -1) && $(this).attr('src').indexOf("enablejsapi=1") > -1) {
            const message = '{"event":"command","func":"stopVideo","args":""}';
            $(this).get(0).contentWindow.postMessage(message, "*");
          }
        });
      }
      $(this).closest(Modal.wrapperClass).removeClass(Website.classList.act).fadeOut(function() {
        $('html').removeClass(Website.classList.modalOpen);
        if(typeof Iscroll !== "undefined" && Iscroll.instance) {
          Iscroll.start();
        }
      });
    });
  }
}

export default Modal;